import type { ProgramDialInInformation } from 'models';
import { useMemo } from 'react';

export const useGetDialInHrefSocial = ({ dialInInformation }: { dialInInformation?: ProgramDialInInformation }) =>
  useMemo(
    () =>
      dialInInformation
        ? {
            href: `tel:${dialInInformation.number};;${dialInInformation.id};;${dialInInformation.passcode}`,
            id: dialInInformation.id,
            number: dialInInformation.number,
            passcode: dialInInformation.passcode,
          }
        : null,
    [dialInInformation],
  );
